<template>
  <div>
    <div class="mb-3">
      <span>封面</span>
    </div>
    <ul>
      <li class="flex-start">
        <span>封面图片</span>
        <template v-if="!data.image">
          <el-button type="text" class="leading-22" @click="onUploadImage">上传图片</el-button>
        </template>
        <template v-else>
          <image-box :src="data.image" @remove="onRemove" />
        </template>
      </li>
      <!--      <li>
        <span>图标大小</span>
        <el-select size="mini-x" class="short-box" v-model="data.title.size" @change="onChange">
          <el-option v-for="item in textSizeOptions" :key="item.value" :value="item.value" :label="item.label" />
        </el-select>
      </li>
      <li>
        <span>文字颜色</span>
        <el-color-picker v-model="data.title.color" @change="onChange" />
      </li>-->
      <li>
        <span>开始按钮底色</span>
        <el-color-picker v-model="data.startBtn.bgColor" @change="onChange" />
      </li>
      <li>
        <span>文字颜色</span>
        <el-color-picker v-model="data.startBtn.textColor" @change="onChange" />
      </li>
      <!--      <li class="flex-start">
        <span class="whitespace-nowrap mr-2">按钮文字</span>
        <div class="text-right">
          <el-input size="mini-x" :maxlength="8" show-word-limit v-model="data.startBtn.text" @change="onChange" />
          <span class="text-small text-theme-black-450">请控制在8个字以内</span>
        </div>
      </li>-->
    </ul>
  </div>
</template>

<script>
import ImageBox from '@/views/survey/edit/aside/appearance/ImageBox'
import { FileErrorCode, uploadFile } from '@dygc/shared'
import { uploadFile as uploadFile2End } from '@/api/file'

export default {
  name: 'H5Cover',
  components: { ImageBox },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      color1: '',
      color2: '',
      color3: '',
      textSizeOptions: []
    }
  },
  created() {
    let sizes = [12, 14, 16, 18, 20, 22, 24, 26, 28]
    this.textSizeOptions = sizes.map(item => {
      return {
        value: item + 'px',
        label: item
      }
    })
  },
  methods: {
    onRemove() {
      this.data.image = ''
      this.onChange()
    },
    onChange() {
      this.$emit('change')
    },
    onUploadImage() {
      const allowTypes = ['jpg', 'jpeg', 'png']
      uploadFile(5, allowTypes, { unit: 'MB' })
        .then(file => {
          let fd = new FormData()
          fd.append('file', file)
          uploadFile2End(fd).then(res => {
            this.data.image = res.data.data.url
            this.$emit('change')
          })
        })
        .catch(err => {
          if (err.code === FileErrorCode.NO_ALLOW_TYPE) {
            this.$message.warning(`仅支持上传${allowTypes.join('、')}格式的图片`)
          } else {
            this.$message.warning(err.msg)
          }
        })
    }
  }
}
</script>
